import type { OMSOrderPropertyEnum } from '@talos/kyoko';

/** Maps OMSOrderPropertyEnum values from pre-trade analytics to Public Markets table field names */
export const PUBLIC_MARKETS_PROPERTY_TO_FIELD = {
  IntervalVolume: 'volumeHorizon',
  AverageDailyVolume: 'adv',
  AverageDailyVolumePct: 'advPct',
  IntervalSpreadBps: 'spread',
  DailySpreadBps: 'spreadDaily',
  IntervalVolatilityBps: 'volatility',
  DailyVolatilityBps: 'volatilityDaily',
} as const satisfies Partial<Record<OMSOrderPropertyEnum, string>>;

export type PublicMarketsFieldName =
  (typeof PUBLIC_MARKETS_PROPERTY_TO_FIELD)[keyof typeof PUBLIC_MARKETS_PROPERTY_TO_FIELD];

export type PublicMarketsNumericFields = Record<PublicMarketsFieldName, number | null>;

export const NUMERIC_FIELDS: readonly PublicMarketsFieldName[] = Object.values(PUBLIC_MARKETS_PROPERTY_TO_FIELD);

export const propertyToField: Partial<Record<OMSOrderPropertyEnum, PublicMarketsFieldName>> =
  PUBLIC_MARKETS_PROPERTY_TO_FIELD;

export interface PublicMarketRowData extends PublicMarketsNumericFields {
  /** Unique row identifier — Symbol when available, otherwise Market name */
  id: string;
  marketName: string;
  /** Present when the API provides a Symbol for this analytic (unified liquidity markets) */
  symbol?: string;
}
